import { API_BASE_URL, X_API_KEY } from './api'
import * as Sentry from '@sentry/react'

interface ContactFormData {
  firstname: string
  title: string
  description: string
  email: string
  userId?: string
}

interface ContactResponse {
  message: string
  contacts?: ContactFormData[]
}

class ContactService {
  private async handleErrors(response: Response): Promise<any> {
    const responseData = await response.json()
    if (!response.ok) {
      const error = new Error(
        responseData.message || 'Une erreur inattendue s’est produite',
      )
      Sentry.captureException(error)
      throw error
    }
    return responseData
  }

  async sendContactForm(data: ContactFormData): Promise<ContactResponse> {
    try {
      const response = await fetch(`${API_BASE_URL}/contacts`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'x-api-key': X_API_KEY,
        },
        body: JSON.stringify(data),
      })
      return this.handleErrors(response)
    } catch (error) {
      Sentry.captureException(error)
      throw error
    }
  }

  async sendAuthContactForm(
    data: ContactFormData,
    token: string,
  ): Promise<ContactResponse> {
    try {
      const response = await fetch(`${API_BASE_URL}/contacts`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
          'x-api-key': X_API_KEY,
        },
        body: JSON.stringify(data),
      })
      return this.handleErrors(response)
    } catch (error) {
      Sentry.captureException(error)
      throw error
    }
  }

  async getContacts(token: string, userId: string): Promise<ContactFormData[]> {
    try {
      const response = await fetch(`${API_BASE_URL}/contacts/${userId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      return this.handleErrors(response)
    } catch (error) {
      Sentry.captureException(error)
      throw error
    }
  }
}

export const contactService = new ContactService()
